import Wrapper from "../../../layout/Wrapper";
import LifeContractReportComponent from "../../../screens/reports/lifeContract";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Life Contract Report",
	description: "",
};

export default function LifeContractReport() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<LifeContractReportComponent />
		</Wrapper>
	);
}